import React from "react";
import { POSITION_COORDS, POSITIONS, toX, toY } from "../constants";
import { PositionSlot } from "./position-slot";
import styles from "./baseball-field.module.css";

export function BaseballField(props) {
  const { positionMap, headshotMap = {}, interactive = true } = props;

  return (
    <div className={styles.field}>
      <svg
        viewBox="0 65 400 280"
        className={styles.svg}
        preserveAspectRatio="xMidYMid meet"
      >
        {/* Warning track */}
        <path d="M 200,330 L 380,150 A 255,255 0 0,0 20,150 Z" fill="#c8a96e" />
        {/* Outfield grass */}
        <path d="M 200,330 L 375,155 A 248,248 0 0,0 25,155 Z" fill="#1e6b30" />
        {/* Infield diamond */}
        <path d="M 200,330 L 268,262 L 200,194 L 132,262 Z" fill="#1e6b30" />
        {/* Infield dirt outline */}
        <path d="M 200,330 L 268,262 L 200,194 L 132,262 Z" fill="none" stroke="#c8a96e" strokeWidth="1" />
        {/* Pitcher's mound */}
        <ellipse cx="200" cy="265" rx="8" ry="5" fill="#c8a96e" />
        {/* Baselines */}
        <line x1="200" y1="330" x2="132" y2="262" stroke="#c8a96e" strokeWidth="1" />
        <line x1="200" y1="330" x2="268" y2="262" stroke="#c8a96e" strokeWidth="1" />
        <line x1="132" y1="262" x2="200" y2="194" stroke="#c8a96e" strokeWidth="1" />
        <line x1="268" y1="262" x2="200" y2="194" stroke="#c8a96e" strokeWidth="1" />
        {/* Bases */}
        <rect x="196" y="326" width="8" height="8" fill="white" transform="rotate(45 200 330)" />
        <rect x="128" y="258" width="8" height="8" fill="white" transform="rotate(45 132 262)" />
        <rect x="196" y="190" width="8" height="8" fill="white" transform="rotate(45 200 194)" />
        <rect x="264" y="258" width="8" height="8" fill="white" transform="rotate(45 268 262)" />
      </svg>

      <div className={styles.overlay}>
        {POSITIONS.map((pos) => {
          const coords = POSITION_COORDS[pos];
          const players = positionMap[pos] || [];
          return (
            <div
              key={pos}
              className={styles.positionAnchor}
              style={{ left: toX(coords.x), top: toY(coords.y) }}
            >
              <PositionSlot
                pos={pos}
                players={players}
                headshotMap={headshotMap}
                interactive={interactive}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
